import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SelectSystem.css';
import { getWarehousesByUser, getWmsAlmacenById, getRoleNames } from '../api.wms';

// Roles WMS definidos estáticamente
const WMS_ROLES = [
  'admin', 'user', 'Creado', 'wms_almacenista', 'wms_supervisor', 'wms_operador',
  'wms_cliente', 'wms_inventarios', 'wms_auditor', 'wms_logistica'
];

const SelectSystem = () => {
  const navigate = useNavigate();
  const [omsRoles, setOmsRoles] = useState([]);

  useEffect(() => {
    const fetchRoleNames = async () => {
      try {
        const roles = await getRoleNames();
        setOmsRoles(roles || []);
      } catch (error) {
        console.error('Error fetching OMS role names:', error);
      }
    };
    fetchRoleNames();
  }, []);

  const userRole = localStorage.getItem('role');
  let userRoles = [];
  try {
    userRoles = userRole ? JSON.parse(userRole) : [];
    if (!Array.isArray(userRoles)) userRoles = [userRole];
  } catch {
    userRoles = userRole ? [userRole] : [];
  }

  const hasOmsRole = useMemo(() => userRoles.some(r => omsRoles.includes(r)), [userRoles, omsRoles]);
  const hasWmsRole = useMemo(() => userRoles.some(r => WMS_ROLES.includes(r)), [userRoles]);

  return (
    <div className="select-system-container">
      <button
        className="logout-button"
        onClick={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          localStorage.removeItem('userName');
          navigate('/login');
        }}
        style={{ position: 'absolute', top: 24, right: 32, background: 'transparent', border: 'none', color: '#1976d2', fontWeight: 'bold', cursor: 'pointer', fontSize: '1rem' }}
        title="Cerrar sesión"
      >
        Cerrar sesión
      </button>
      <h1>Selecciona el sistema</h1>
      <div className="select-system-buttons">
        <button
          className="system-button"
          onClick={() => navigate('/tms')}
          disabled={!hasOmsRole}
          title={!hasOmsRole ? 'No tienes acceso a TMS' : ''}
          style={{
            opacity: hasOmsRole ? 1 : 0.5,
            cursor: hasOmsRole ? 'pointer' : 'not-allowed',
            transition: 'opacity 0.2s',
          }}
        >
          Entrar a TMS
        </button>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <button
            className="system-button"
            onClick={async () => {
              const userId = localStorage.getItem('userId');
              if (!userId) {
                alert('No se encontró el usuario.');
                return;
              }
              try {
                if (userRoles.includes('admin')) {
                  const prev = localStorage.getItem('wms_warehouse');
                  let prevObj = {};
                  try { prevObj = prev ? JSON.parse(prev) : {}; } catch {}
                  const newObj = { ...prevObj, warehouse_id: 'all', warehousename: 'Todos los almacenes' };
                  localStorage.setItem('wms_warehouse', JSON.stringify(newObj));
                  navigate('/wms');
                  return;
                }
                const warehouses = await getWarehousesByUser(userId);
                if (!warehouses || warehouses.length === 0) {
                  alert('No tienes almacén asignado.');
                  return;
                }
                const warehouse_id = warehouses[0];
                const warehouseData = await getWmsAlmacenById(warehouse_id);
                const warehousename = warehouseData?.nombre || 'Sin nombre';
                const prev = localStorage.getItem('wms_warehouse');
                let prevObj = {};
                try { prevObj = prev ? JSON.parse(prev) : {}; } catch {}
                const newObj = { ...prevObj, warehouse_id, warehousename };
                localStorage.setItem('wms_warehouse', JSON.stringify(newObj));
                navigate('/wms');
              } catch (err) {
                alert('Error al obtener almacén: ' + (err?.response?.data?.detail || err.message));
              }
            }}
            disabled={!hasWmsRole}
            title={!hasWmsRole ? 'No tienes acceso a WMS' : ''}
            style={{
              opacity: hasWmsRole ? 1 : 0.5,
              cursor: hasWmsRole ? 'pointer' : 'not-allowed',
              transition: 'opacity 0.2s',
            }}
          >
            Entrar a WMS
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectSystem;
